import { Button } from "reactstrap";

interface Props {
  query: any;
  setQuery: (newQuery: any) => void;
}

const CreatedSortByButton = ({ query, setQuery }: Props) => {
  return (
    <Button size="sm" onClick={changeDirection}>
      {query?.OrderBy?.Direction === "ASC" ? "Oldest First" : "Newest First"}
    </Button>
  );

  function changeDirection() {
    const newQuery = { ...query };

    if (newQuery?.OrderBy?.Direction === "DESC") {
      newQuery.OrderBy.Direction = "ASC";
    } else {
      newQuery.OrderBy.Direction = "DESC";
    }

    setQuery(newQuery);
  }
};

export default CreatedSortByButton;
